exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sink-delete-column{width:20%}.sink-name-column{color:white;width:60%}.sink-delete{position:relative}.sink-delete:hover{color:red !important}.sink-status{min-width:80px;text-align:left}.sink-active-column{width:20%}\n", ""]);

// exports
